import { initializeApp } from "firebase/app";
import { notifySuccess } from "./notify";

import {
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  linkWithCredential,
  OAuthProvider,
  PhoneAuthProvider,
  RecaptchaVerifier,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  signInWithPopup,
  signOut,
  unlink,
  updateProfile,
} from "firebase/auth";

import {
  getMe,
  updateProfile as updateProfileAPI,
} from "../api/bernabeu";

import {
  clearAnalyticsUserId,
  setAnalyticsUserId,
} from "./analytics";

import * as authSlice from "../../redux/reducers/authSlice";

const firebaseConfig = {
  apiKey: "AIzaSyDK2X1k1xvz_TF-ZHeuwdk4lydRhZo3cmY",
  authDomain: "atacante-app.firebaseapp.com",
  databaseURL: "https://atacante-app.firebaseio.com",
  projectId: "atacante-app",
  storageBucket: "atacante-app.appspot.com",
  messagingSenderId: "436650534114",
  appId: "1:436650534114:web:dcdd0b70c0b49cbe776abb",
  measurementId: "G-JW6NTFH460",
  languageCode: "pt-br",
};

const { actions } = authSlice;
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const recaptcha = (container) => {
  return new Promise((resolve, reject) => {

    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
    }

    window.recaptchaVerifier = new RecaptchaVerifier(container, { 'size': 'invisible' }, auth);
    window.recaptchaVerifier.render();
  });
}

export const verifyLogged = (navigate, location, verify: boolean = true) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setLoading(true));
    console.log('entrou verifyLogged')
    console.log(verify);

    if (getAuth().currentUser) {
      getAuth().currentUser!.getIdToken(true).then((idToken) => {
        dispatch(actions.login(idToken));

        if (verify === true) {
          const currentUser = getAuth().currentUser;

          const hasPhoneProvider = currentUser?.providerData?.some(
            (provider) => provider.providerId === 'phone'
          );

          getMe().then((me: any) => {
            console.log(me);
            dispatch(actions.setUser({
              id: me.data.id,
              name: me.data.attributes.name,
              phone: me.data.attributes.phone,
              email: me.data.attributes.email,
              date_expire: me.data.attributes.date_expire ?? '',
            }));
            setAnalyticsUserId(String(me.data.id));

            const hasName = me.data.attributes.name && me.data.attributes.name.trim() !== '';
            const hasEmail = me.data.attributes.email && me.data.attributes.email.trim() !== '';

            if ((!hasName || !hasEmail) && hasPhoneProvider) {
              navigate !== false && setTimeout(() => navigate({}, { state: { completeProfile: location } }), 500);
              dispatch(actions.setLoading(false));
              resolve(true);
              return;
            }
          }).catch((error: any) => {
            dispatch(actions.setLoading(false));
            reject(false);
          });
        }

        resolve(true);
      }).catch((response :any) => {
        dispatch(actions.setLoading(false));

        reject(false);
      }).finally(() => {
        console.log('finally verifyLogged')
        dispatch(actions.setLoading(false));
        dispatch(actions.setActionLoading(false));
      });
    } else {
      dispatch(logout());
      dispatch(actions.setLoading(false));
      dispatch(actions.setActionLoading(false));

      resolve(true);
    }
  });
}

export const loginWithGoogle = (signIn = true) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    const provider : any = new GoogleAuthProvider();
    provider.addScope(['email', 'profile']);

    signInWithPopup(auth, provider)
      .then((result) => {
        const user : any = result.user;

        dispatch(actions.login(user.accessToken));
        resolve(true);
      }).catch((error) => {
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const loginWithFacebook = (signIn = true) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    const provider : any = new FacebookAuthProvider();

    provider.addScope(['public_profile', 'email']);

    provider.setCustomParameters({
      'display': 'popup'
    });

    signInWithPopup(auth, provider)
      .then((result) => {
        // const user : any = result.user;

        const credential : any = FacebookAuthProvider.credentialFromResult(result);
        const accessToken : any = credential.accessToken;

        dispatch(actions.login(accessToken));
        resolve(true);
      })
      .catch((error) => {
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const loginWithApple = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    const provider = new OAuthProvider('apple.com');

    provider.addScope('email');
    provider.addScope('name');

    provider.setCustomParameters({
      locale: 'pt_BR'
    });

    signInWithPopup(auth, provider)
    .then((result) => {
      const user: any = result.user;

      dispatch(actions.login(user.accessToken));
      resolve(true);
    })
    .catch((error) => {
      reject(translateError(error.code));
    }).finally(() => {
      dispatch(actions.setActionLoading(false));
    });
  });
}

export const loginWithEmail = (email, password) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    signInWithEmailAndPassword(auth, email, password)
      .then((result) => {
        const user : any = result.user;

        dispatch(actions.login(user.accessToken));
        resolve(true);
      })
      .catch((error) => {
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const signUpWithEmail = (name, email, password) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        const user : any = result.user;

        // Atualizar o perfil do Firebase com o nome
        updateProfile(user, {
          displayName: name
        }).then(() => {
          dispatch(actions.login(user.accessToken));

          // Após o login, atualizar o perfil no backend
          user.getIdToken(true).catch((error) => {
            console.error('Erro ao obter token:', error);
          });

          resolve(true);
        }).catch((error) => {
          // Mesmo se falhar ao atualizar o perfil, continuamos com o login
          console.error('Erro ao atualizar perfil do Firebase:', error);
          dispatch(actions.login(user.accessToken));

          // Tentar atualizar o backend mesmo assim
          user.getIdToken(true).catch((error) => {
            console.error('Erro ao obter token:', error);
          });

          resolve(true);
        });
      })
      .catch((error) => {
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const requestCodePhoneVerification = (phone) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    signInWithPhoneNumber(auth, phone, window.recaptchaVerifier)
      .then((result) => {
        console.log(result);
        resolve(result);
      })
      .catch((error) => {
        console.log(error)
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const validatePhone = (verification, code) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    const credential = PhoneAuthProvider.credential(verification.verificationId, code);

    linkWithCredential(getAuth().currentUser!, credential)
      .then((result) => {
        resolve(true);
        notifySuccess("Telefone foi validado com sucesso", 'validatePhone');
      }).catch((error) => {
        console.log(error)
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const loginWithPhone = (verification, code) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    verification.confirm(code)
      .then((result) => {
        const user : any = result.user;
        dispatch(actions.login(user.accessToken));
        resolve(true);
      }).catch((error) => {
        console.log(error)
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const resetPasswordWithEmail = (email) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    sendPasswordResetEmail(auth, email)
      .then((result) => {
        console.log({result});
        notifySuccess("E-mail de recuperação de senha enviado!", 'resetPasswordWithEmail');

        resolve(true);
      })
      .catch((error) => {
        reject(translateError(error.code));
      }).finally(() => {
        dispatch(actions.setActionLoading(false));
      });
  });
}

export const logout = () => dispatch => {
  console.log('logout')
  clearAnalyticsUserId();
  signOut(auth).then(() => {
    console.log('signOut')
    dispatch(actions.logout());
  });
}

export const getSessionIdFromToken = (authToken?: string): number => {
  if (authToken) {
    try {
      const payload = JSON.parse(atob(authToken.split('.')[1]));

      if (payload.auth_time) {
        return payload.auth_time * 1000;
      }
    } catch {
      // token inválido ou malformado
    }
  }

  const lastSignInTime = getAuth().currentUser?.metadata?.lastSignInTime;

  if (lastSignInTime) {
    return new Date(lastSignInTime).getTime();
  }

  return Date.now();
};

export const getMeInfo = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    getMe().then((response: any) => {
      dispatch(actions.setActionLoading(false));

      resolve(response.data)
    }).catch(error => {
      dispatch(actions.setActionLoading(false));

      reject(false);
    });
  });
}

export const updateUserName = (name, reload = true) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    updateProfile(getAuth().currentUser!, {
      displayName: name
    }).then(() => {
      notifySuccess("Perfil atualizado com sucesso", 'updateUserName');

      dispatch(verifyLogged(false, false, reload));
      resolve(true);
    }).catch(() => {
      reject(false);
    }).finally(() => {
      dispatch(actions.setActionLoading(false));
    });
  });
}

export const completeUserProfile = (name, email, reload = true) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.setActionLoading(true));

    updateProfileAPI({
      email: email,
      name: name
    }).then(() => {
      notifySuccess("Perfil atualizado com sucesso", 'completeUserProfile');
      dispatch(verifyLogged(false, false, reload));
      resolve(true);
    }).catch((error) => {
      reject(translateError(error.code));
    }).finally(() => {
      dispatch(actions.setActionLoading(false));
    });
  });
}

export const unlinkProvider = (provider) => dispatch => {
  return unlink(getAuth().currentUser!, provider).then(() => {
    if (provider === 'phone') {
      notifySuccess("Número removido, válide outro número para continuar", 'unlinkProvider');
    } else {
      notifySuccess("Desvinculado com sucesso", 'unlinkProvider');
    }

    dispatch(verifyLogged(false, false));
  }).catch((error) => {
    console.log('unlinkPhone error:');
    console.log(error);

    notifySuccess("Erro na requisição", 'unlinkProvider');
  });
}



export const translateError = (errorCode) => {
  if (errorCode === 'auth/credential-already-in-use') {
    return 'Telefone já está associado a outro usuário!'
  }
  if (errorCode === 'auth/email-already-in-use') {
    return 'E-mail já está sendo utilizado'
  }

  if (errorCode === 'auth/invalid-email') {
    return 'E-mail inválido'
  }

  if (errorCode === 'auth/missing-email') {
    return 'E-mail é obrigatório'
  }

  if (errorCode === 'auth/missing-password') {
    return 'Senha é obrigatório'
  }

  if (errorCode === 'auth/invalid-credentials') {
    return 'E-mail inválido'
  }

  if (errorCode === 'auth/weak-password') {
    return 'Sua senha deve conter pelo menos 6 digitos'
  }

  if (errorCode === 'auth/wrong-password') {
    return 'E-mail ou senha inválido'
  }

  if (errorCode === 'auth/user-not-found') {
    return 'E-mail ou senha inválido'
  }

  if (errorCode === 'auth/too-many-requests') {
    return 'Usuário temporariamente bloqueado por muitas tentativas'
  }

  if (errorCode === 'auth/user-disabled') {
    return 'Usuário foi desativado, tente outro e-mail'
  }

  if (errorCode === 'auth/session-expired') {
    return 'Código expirou ou já foi utilizado, reenvie um novo código!'
  }

  if (errorCode === 'auth/invalid-verification-code') {
    return 'Código inválido!'
  }

  if (errorCode === 'auth/provider-already-linked') {
    return 'Você já associou um telefone na sua conta!'
  }

  if (errorCode === 'auth/account-exists-with-different-credential') {
    return 'Outra conta já associada!'
  }

  if (errorCode === 'auth/captcha-check-failed') {
    return 'Falhou a validação do reCAPTCHA, tente novamente!'
  }

  if (errorCode === 'auth/invalid-phone-number') {
    return 'Telefone inválido'
  }

  if (errorCode === 'auth/missing-phone-number') {
    return 'Preencha com seu telefone, você também pode preencher mais tarde essa informação'
  }

  if (errorCode === 'auth/quota-exceeded') {
    return 'Válidação do seu usuário foi desabilitada temporariamente, tente novamente daqui alguns minutos'
  }

  if (errorCode === 'auth/requires-recent-login') {
    return 'Necessário realizar um novo login.'
  }

  if (errorCode === 'auth/popup-closed-by-user') {
    return 'Popup de autenticação fechada pelo usuário'
  }

  if (errorCode === 'auth/internal-error') {
    return 'Erro a executar ação'
  }

  return errorCode;
}